<template>
  <div class="hardware-main">
    <div class="hardware-box">
      <div class="hardware-title">{{ $t('hardsenven.mechanical_title') }}</div>
      <div class="hardware-li">{{ $t('hardsenven.mechanical_dimensions') }}</div>
      <div class="hardware-li">{{ $t('hardsenven.mechanical_conveyor_length') }}</div>
      <div class="hardware-li">{{ $t('hardsenven.mechanical_conveyor_weight') }}</div>
      <div class="hardware-li">{{ $t('hardsenven.mechanical_conveyor_height') }}</div>
      <div class="hardware-li">{{ $t('hardsenven.mechanical_box_size') }}</div>
      <div class="hardware-title">{{ $t('hardsenven.electrical_title') }}</div>
      <div class="hardware-li">{{ $t('hardsenven.electrical_power') }}</div>
      <div class="hardware-li">{{ $t('hardsenven.electrical_voltage') }}</div>
      <div class="hardware-li">{{ $t('hardsenven.electrical_computer') }}</div>
      <div class="hardware-title">{{ $t('hardsenven.rfid_title') }}</div>
      <div class="hardware-li">{{ $t('hardsenven.rfid_reader') }}</div>
      <div class="hardware-li">{{ $t('hardsenven.rfid_antenna') }}</div>
      <div class="hardware-li">{{ $t('hardsenven.rfid_speed') }}</div>
      <div class="hardware-li">{{ $t('hardsenven.rfid_quantity') }}</div>
      <div class="hardware-li">{{ $t('hardsenven.rfid_frequency') }}</div>
      <div class="hardware-title">{{ $t('hardsenven.environment_title') }}</div>
      <div class="hardware-li">{{ $t('hardsenven.environment_working_temp') }}</div>
      <div class="hardware-li">{{ $t('hardsenven.environment_storage_temp') }}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
</style>